import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { useLanguage } from '../contexts/LanguageContext';
import { supabase } from '../supabase';
import '../styles/DocumentResubmit.css';
import { Check } from 'lucide-react';

function DocumentResubmit({ title }) {
  const { selectedWorkspaceId } = useWorkspace(); 
  const { language } = useLanguage();
  const [documents, setDocuments] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const fetchDocuments = async () => {
      if (!selectedWorkspaceId) return;

      try {
        const { data, error } = await supabase
          .from('documents')
          .select('id, name')
          .eq('workspace_id', selectedWorkspaceId)
          .eq('is_deleted', false);

        if (error) throw error;
        setDocuments(data);
      } catch (error) {
        setError(`Error fetching documents: ${error.message}`);
      }
    };

    fetchDocuments();
  }, [selectedWorkspaceId]);

  const options = documents.map(doc => ({
    value: doc.id,
    label: doc.name,
  }));

  const handleSubmit = async () => {
    if (selectedDocuments.length === 0) {
      setError(language === 'en' ? "Please select at least one document to assign." : "Bitte wählen Sie mindestens ein Dokument aus.");
      return;
    }

    setError('');
    setSuccessMessage('');

    try {
      const { error: updateError } = await supabase
        .from('tasks')
        .update({ assigned_documents: selectedDocuments })
        .eq('name', title);

      if (updateError) throw updateError;

      setSuccessMessage(language === 'en' ? "Documents assigned successfully!" : "Dokumente erfolgreich zugewiesen!");
      setSelectedDocuments([]);
    } catch (err) {
      setError(`Submission failed: ${err.message}`);
    }
  };

  return (
    <div className="document-resubmit-container">
      <p>{language === 'en' ? 'Assign Previously Uploaded Document(s)' : 'Zuvor hochgeladene Dokumente zuweisen'}</p>
      
      <div className="dropdown-container">
        <Select
          isMulti
          name="documents"
          options={options}
          value={options.filter(option => selectedDocuments.includes(option.value))}
          onChange={(selectedOptions) => {
            setSelectedDocuments(selectedOptions.map(option => option.value));
          }}
          className="basic-multi-select"
          classNamePrefix="select"
          placeholder={language === 'en' ? "Select document(s)" : "Dokument(e) auswählen"}
        />
      </div>

      {error && <p className="error">{error}</p>}
      {successMessage && <p className="success">{successMessage}</p>}

      <button 
        onClick={handleSubmit}
        style={{
          display: selectedDocuments.length > 0 ? 'inline-flex' : 'none',
          width: '100%',
          maxWidth: '200px',
          margin: '15px 0px',
          background: '#5F6975',
          color: 'rgb(255, 255, 255)',
          padding: '10px',
          border: 'none',
          borderRadius: '5px',
          fontWeight: 'bold',
          cursor: 'pointer',
          transition: '0.3s',
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Check size={14} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
        {language === 'en' ? 'Submit' : 'Einreichen'}
      </button>
    </div>
  );
}

export default DocumentResubmit;
